// src/ui/ProfileFacts.jsx — the optional answers a profile chose to show.
//
// 🟥 THERE IS NO FILTER IN HERE, AND THAT IS THE GUARANTEE. It is handed the
//    `profileFields` map off a document, and an answer whose owner kept it back
//    is not in that map: it lives in a subcollection only the owner may read.
//    So there is no visibility check to forget and no projection to get wrong.
//    See app/services/profileStore.ts for why it is stored that way.
//
// 🟢 SAME CATALOGUE AS THE PHONE, through the generated twin — the same fields,
//    the same wording in the same ten languages, and the same rule for turning
//    a handle somebody typed into a link that opens.

import React from 'react';
import {
  publicFields, fieldLabel, fieldDisplay, fieldLink,
} from '../services/profileFields';

export default function ProfileFacts({ fields, lang }) {
  const rows = publicFields(fields || {});
  if (!rows.length) return null;
  return (
    <>
      {rows.map((r) => {
        const href = fieldLink(r.key, r.value);
        const text = fieldDisplay(r.key, r.value, lang);
        const label = fieldLabel(r.key, lang);
        return href ? (
          <a key={r.key} className="vb-fact" href={href} target="_blank" rel="noreferrer" title={label}>
            {label}: {text}
          </a>
        ) : (
          <span key={r.key} className="vb-fact" title={label}>{label}: {text}</span>
        );
      })}
    </>
  );
}
